module.exports = __webpack_public_path__ + "static/media/affilatedBanner.6ad7ee3a.svg";